import React, { useContext, useCallback, useState, Fragment, useEffect } from 'react';
import { CurrentPageContext } from '../general-components/HistoryStackContext';
import { useLocalizedStrings } from 'app/localization/Context';
import Popup, { usePopup } from 'app/home/general-components/Popup/Popup';
import { stringFormat } from 'app/model/BindData';
import CustomIconBack from '../home-components/CustomIconBack';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconPlus } from 'images/general/icon-add-black.svg';
import { ReactComponent as IconTick } from 'images/general/tick-blue.svg';
import { ReactComponent as IconLogout } from 'images/general/logout.svg';
import { ReactComponent as IconLogoutRed } from 'images/general/logout-red.svg';

import { ReactComponent as IconDeleteRed } from 'images/general/delete-red.svg';
import { ReactComponent as IconDeleteWhite } from 'images/general/delete-white.svg';

import { ReactComponent as AvatarBlue1 } from 'images/home/blue/homes-1.svg';
import { ReactComponent as AvatarBlue2 } from 'images/home/blue/homes-2.svg';
import { ReactComponent as AvatarBlue3 } from 'images/home/blue/homes-3.svg';
import { ReactComponent as AvatarBlue4 } from 'images/home/blue/homes-4.svg';
import { ReactComponent as AvatarBlue5 } from 'images/home/blue/homes-5.svg';
import { ReactComponent as AvatarWhite1 } from 'images/home/white/homes-1.svg';
import { ReactComponent as AvatarWhite2 } from 'images/home/white/homes-2.svg';
import { ReactComponent as AvatarWhite3 } from 'images/home/white/homes-3.svg';
import { ReactComponent as AvatarWhite4 } from 'images/home/white/homes-4.svg';
import { ReactComponent as AvatarWhite5 } from 'images/home/white/homes-5.svg';


import './HomeList.scss'

export default function HomeList({
    homes, activeHome, reloadSoloHomes, onAddHomeClick,
    isSoloLoggedIn, logoutFromSolo,
    customDismiss, showBackground, blurBackground }) {

    const p = useContext(CurrentPageContext);
    const dismissPage = useCallback((optionalDismiss) => {
        if (customDismiss) {
            if (!optionalDismiss) {
                customDismiss();
            } else {
                console.log("optionalDismiss is", optionalDismiss)
            }
        } else {
            p.dismiss();
        }
    }, [p, customDismiss]);

    const s = useLocalizedStrings();

    const [logoutPopupId, showLogoutPopup, dismissLogoutPopup] = usePopup();
    const [exitHomePopupId, showExitHomePopup, dismissExitHomePopup] = usePopup();

    const [exitingHome, setExitingHome] = useState(undefined);

    const _onAddHomeClick = useCallback(() => {
        onAddHomeClick();
        setTimeout(() => {
            dismissPage(true);
        }, 1000);
    }, [onAddHomeClick, dismissPage]);

    const [reloadedOnce, setReloadedOnce] = useState(false);
    useEffect(() => {
        // console.log("reload", reloadedOnce, reloadSoloHomes)
        if (!reloadedOnce) {
            if (reloadSoloHomes) {
                setReloadedOnce(true);
                reloadSoloHomes();
            }
        }
    }, [reloadSoloHomes, reloadedOnce])

    const onExitHomeConfirmed = useCallback((leaveAndDelete = false) => {
        dismissExitHomePopup();

        setTimeout(() => {
            const isLastHome = homes.length === 1;
            const isTheActiveHome = exitingHome === activeHome;

            if (exitingHome.isSolo) {
                exitingHome.remove(leaveAndDelete, () => { // ok
                    if (isLastHome) {
                        setTimeout(() => {
                            dismissPage(true); // whole page
                        }, 1000);
                    } else if (isTheActiveHome) { // remove will switch the home
                        window.location.reload();
                    }
                });
            } else {
                exitingHome.remove();
                if (isLastHome) {
                    setTimeout(() => {
                        dismissPage(true); // whole page
                    }, 1000);
                } else if (isTheActiveHome) { // remove will switch the home
                    window.location.reload();
                }
            }
        });
    }, [activeHome, dismissExitHomePopup, dismissPage, exitingHome, homes.length]);

    const showBigAddHomeButton = homes.length <= 3;

    return (
        <div className="home-list-page">
            {showBackground ? <Fragment>
                <div className="bg-blank" />
                <div className="bg-secondary-color" />
            </Fragment> : null}
            <div className={"home-list-page-content override-view" + (blurBackground ? " blur-background" : "")}>
                <div className="nav-button" onClick={() => { dismissPage(false) }} />
                <div className="header-group">
                    {blurBackground ?
                        <IconX className="x-icon" /> :
                        <CustomIconBack className="back-icon" />}
                    <div />
                    {!showBigAddHomeButton ? <div className="button-border blue" onClick={_onAddHomeClick}>
                        <div className="label">{s.addHome}</div>
                        <IconPlus className="icon" />
                    </div> : null}
                    {isSoloLoggedIn ? <div className="button-border" onClick={() => { showLogoutPopup() }}>
                        <div className="label">{s.logoutSolo}</div>
                        <IconLogout className="icon" />
                    </div> : null}
                </div>

                <div className="header">{s.homeManagement}</div>

                <div className="homes">
                    {
                        (homes.length > 0) ?
                            homes.map((home) => {
                                const {
                                    avatarImage, nameClass,
                                    tick, onSwitchClick,
                                    detail
                                } = prepareHomeForView(s, () => {
                                    dismissPage(true);
                                    setTimeout(() => {
                                        home.switch();
                                        window.location.reload(); // reload after switch to clear memory (and ws connection)
                                    }, 1000);
                                }, home, activeHome);

                                return (
                                    <div className="home-cell" key={"switch_home_key_" + String(home.phoneNumber) + "_" + String(home.home_id)}>
                                        <div className="start" onClick={onSwitchClick}>
                                            {React.createElement(avatarImage, { className: "avatar" })}
                                        </div>
                                        <div className="middle" onClick={onSwitchClick}>
                                            <div className={nameClass}>{home.name} {tick}</div>
                                            <div className="phone-number">{detail}</div>
                                        </div>
                                        <div className="end">
                                            <div className="button" onClick={() => {
                                                setExitingHome(home);
                                                showExitHomePopup();
                                            }}>
                                                <div className="label">{s.exitHome}</div>
                                                <IconDeleteWhite className="icon" />
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) :
                            <div className="empty-list-cell">{s.noHomeInList}</div>
                    }
                </div>

                {showBigAddHomeButton ? <div className="add-another-home-button"
                    onClick={_onAddHomeClick}>
                    <div>{s.addHome}</div> <IconPlus className="icon" />
                </div> : null}

                <LeaveHomePopup
                    exitHomePopupId={exitHomePopupId}
                    exitingHome={exitingHome}
                    dismissExitHomePopup={dismissExitHomePopup}
                    onExitHomeConfirmed={onExitHomeConfirmed} />

                <Popup popupId={logoutPopupId} name="logout_solo_popup" baseZIndex={12}>
                    <div className="general-popup">
                        <div className="header">{s.logoutSoloConfirmPopup.header}</div>
                        <div className="body with-more-margin">{s.logoutSoloConfirmPopup.info}</div>
                        <div className="button red c1-4 with-icon with-padding" onClick={() => { logoutFromSolo(); dismissLogoutPopup() }}>
                            <div className="label">{s.logoutSoloConfirmPopup.ok}</div>
                            <IconLogoutRed className="icon" />
                        </div>
                        <div className="button black c4-7" onClick={dismissLogoutPopup}>{s.logoutSoloConfirmPopup.no}</div>
                    </div>
                </Popup>
            </div>
        </div>
    )
}

export function LeaveHomePopup({ exitingHome, exitHomePopupId, dismissExitHomePopup, onExitHomeConfirmed }) {
    const s = useLocalizedStrings();

    return (
        <Popup popupId={exitHomePopupId} name="leave_home_popup" baseZIndex={12}>
            {(exitingHome !== undefined) ? <div className="general-popup">
                <div className="header">{stringFormat(s.exitHomePopup.header, exitingHome.name)}</div>

                {exitingHome.is_admin ? (
                    exitingHome.no_other_admin ? ( // only admin
                        <Fragment>
                            <div className="body with-more-margin">{s.exitHomePopup.onlyAdminInfo}</div>
                            <div className="button red c1-4 with-icon with-padding" onClick={() => { onExitHomeConfirmed(true) }}>
                                <div className="label">{s.exitHomePopup.leaveAndDelete}</div>
                                <IconDeleteRed className="icon" />
                            </div>
                            <div className="button black c4-7" onClick={dismissExitHomePopup}>{s.exitHomePopup.no}</div>
                        </Fragment>
                    ) : ( // admin beside other admins
                        <Fragment>
                            <div className="body with-more-margin">{s.exitHomePopup.adminInfo}</div>
                            <div className="button red c1-3 with-icon with-padding" onClick={() => { onExitHomeConfirmed(false) }}>
                                <div className="label">{s.exitHomePopup.leave}</div>
                                <IconDeleteRed className="icon" />
                            </div>
                            <div className="button red c3-5 with-icon with-padding" onClick={() => { onExitHomeConfirmed(true) }}>
                                <div className="label">{s.exitHomePopup.leaveAndDelete}</div>
                                <IconDeleteRed className="icon" />
                            </div>
                            <div className="button black c5-7" onClick={dismissExitHomePopup}>{s.exitHomePopup.no}</div>
                        </Fragment>
                    )
                ) : ( // non admin
                    <Fragment>
                        <div className="body with-more-margin">{s.exitHomePopup.nonAdminInfo}</div>
                        <div className="button red c1-4 with-icon with-padding" onClick={() => { onExitHomeConfirmed(false) }}>
                            <div className="label">{s.exitHomePopup.leave}</div>
                            <IconDeleteRed className="icon" />
                        </div>
                        <div className="button black c4-7" onClick={dismissExitHomePopup}>{s.exitHomePopup.no}</div>
                    </Fragment>
                )}

            </div> : null}
        </Popup>
    )
}

export function getHomeAvatar(id, isBlue) {
    if (isBlue) {
        switch (id) {
            case 1:
                return AvatarBlue1;
            case 2:
                return AvatarBlue2;
            case 3:
                return AvatarBlue3;
            case 4:
                return AvatarBlue4;
            case 5:
            default:
                return AvatarBlue5;
        }
    } else {
        switch (id) {
            case 1:
                return AvatarWhite1;
            case 2:
                return AvatarWhite2;
            case 3:
                return AvatarWhite3;
            case 4:
                return AvatarWhite4;
            case 5:
            default:
                return AvatarWhite5;
        }
    }
}

function insert(str, index, value) {
    return str.substr(0, index) + value + str.substr(index);
}

export function prepareHomeForView(s, _onSwitchClick, home, activeHome) {
    let avatarImage = undefined;
    let nameClass = undefined;
    let tick = undefined;
    let onSwitchClick = undefined;

    if (home === activeHome) {
        nameClass = "label selected";
        tick = <IconTick className="tick-icon" />;
        onSwitchClick = () => { };
        avatarImage = getHomeAvatar(home.avatar, true);
    } else {
        nameClass = "label";
        tick = <div />;
        onSwitchClick = _onSwitchClick;
        avatarImage = getHomeAvatar(home.avatar, false);
    }

    let detail = "";
    if (home.isSolo) {
        // detail = home.home_id;
        detail = s.homeType.solo;
    } else {
        detail =
            insert(
                insert(
                    insert(
                        home.phoneNumber,
                        3, " "),
                    7, " "),
                11, " ");
    }

    return {
        avatarImage, nameClass,
        tick, onSwitchClick,
        detail,
    }
}